import { useState, useEffect } from "react";
import moment from "moment";

import { TABPARAMNAME } from "../../../../constants/clientsDashboard";
import {
  PreviousEiacFilter,
  UseGetEiacDataProps,
  UseGetEiacDataReturn,
} from "./useGetEiacData-types";
import { IGetEiacFilesCountData } from "../../../../services/ClientsDashboardServices.dto";
import ClientsDashboardServices from "../../../../services/ClientsDashboardServices";

const useEiacData = ({ filter, tabParam }: UseGetEiacDataProps): UseGetEiacDataReturn => {
  const [previousFilter, setPreviousFilter] = useState<PreviousEiacFilter>({
    from: "",
    to: "",
    mediatorCode: "",
    fileType: "all",
  });
  const [data, setData] = useState<IGetEiacFilesCountData[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const today = moment().format("DD/MM/YYYY");
    if (today === filter.from && today === filter.to) {
      handleGetEiacData();
    }
  }, []);

  useEffect(() => {
    if (previousFilter.mediatorCode !== filter.mediatorCode) {
      setData(null);
    }
  }, [filter.mediatorCode]);

  const handleGetEiacData = async () => {
    if (tabParam !== TABPARAMNAME.FICHEROS_EIAC) return;

    setPreviousFilter(filter);
    setLoading(true);

    const response = await ClientsDashboardServices.getEiacFilesCount({
      loader: false,
      setLoading: () => {},
      from: filter.from.replace(/\//g, "-"),
      to: filter.to.replace(/\//g, "-"),
      mediatorCode: filter.mediatorCode,
    });

    if (response.ok) {
      setData(response.data);
    } else {
      setError(response.message || "");
    }

    setLoading(false);
  };

  return {
    data,
    loading,
    error,
    handleGetEiacData,
  };
};

export default useEiacData;
